import React, { useEffect, useState } from 'react'
import { EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { Typography } from 'antd'
import {
  fetchVenueSupplierProducts,
  fetchVenueSuppliers,
} from 'src/features/OrdersCaptureSlice'
import { useSelector } from 'react-redux'
const { Text } = Typography
import { compareTwoStrings } from 'string-similarity'
import styled from 'styled-components'

const StyledTable = styled.table`
  td {
    padding-bottom: 20px;
    padding-top: 6px;
  }
`
const CoPilotInterpretation = ({
  omsOrders,
  parsedOrder,
  newProducts,
  setNewProducts,
  supplierProducts,
  setSupplierProducts,
}) => {
  const [venueSupplier, setVenueSupplier] = useState(null)
  const accountId = useSelector(state => state.auth.account._id)

  const isProductInSupplierList = (supplierProducts, productId) => {
    const isExist = supplierProducts?.find(product => product._id === productId)
    return isExist
  }
  useEffect(() => {
    const fetchProducts = async () => {
      const suppliers = await fetchVenueSuppliers(
        accountId,
        parsedOrder?.order?.venue?._id,
      )
      if (suppliers?.length > 0) {
        setVenueSupplier(suppliers[0])
        const products = await fetchVenueSupplierProducts(suppliers[0]?._id)
        setSupplierProducts(products)
      }
    }
    if (
      parsedOrder?.order?.orderIds?.length === 0 &&
      parsedOrder?.order?.venue?._id
    ) {
      fetchProducts()
    } else {
      setSupplierProducts([])
      setVenueSupplier(null)
    }
  }, [parsedOrder])

  useEffect(() => {
    if (supplierProducts.length > 0) {
      const updatedProducts = parsedOrder?.order?.order?.products?.map(
        orderProduct => {
          const foundProduct = supplierProducts.find(product => {
            return compareTwoStrings(product.title, orderProduct.title) >= 0.5
          })
          return foundProduct
            ? {
                ...foundProduct,
                id: foundProduct._id + Math.random().toString(36).substring(7),
              }
            : orderProduct
        },
      )
      setNewProducts(updatedProducts)
    } else {
      setNewProducts(parsedOrder?.order?.order?.products)
      setVenueSupplier(null)
    }
  }, [supplierProducts, parsedOrder])

  return (
    <>
      {parsedOrder?.order?.orderIds?.length !== 0 ? (
        <div style={{ fontSize: '14px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <p>Venue Name: {omsOrders[0]?.venue?.title}</p>
              <p>Customer Name: {parsedOrder?.order?.customer?.name}</p>
              <p>Customer Email: {parsedOrder?.order?.customer?.email}</p>
              <p>Supplier Name: {omsOrders[0]?.supplier?.title}</p>
              <p>
                Order Date:{' '}
                {new Date(omsOrders[0]?.orderedDate).toLocaleDateString()}
              </p>
              <p>
                Delivery Date:{' '}
                {new Date(
                  omsOrders[0]?.requiredDeliveryDay,
                ).toLocaleDateString() || 'Next Available Delivery Day'}
              </p>
            </div>
            <EditOutlined
              style={{
                fontSize: '20px',
                color: '#007bff',
                cursor: 'pointer',
                marginBottom: '180px',
              }}
              onClick={() => {
                const orderId = parsedOrder?._id
                if (orderId) {
                  window.open(
                    `/supplier/co-pilot/${orderId}/editOrder`,
                    '_blank',
                  )
                }
              }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              borderBottom: '1px solid #ddd',
              marginBottom: '15px',
            }}
          ></div>
          <div></div>
          <StyledTable style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ fontSize: '14px' }}>
              <tr>
                <th>Sku</th>
                <th>Product</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Total</th>
                <th>Confidence Score</th>
              </tr>
            </thead>
            <tbody style={{ marginTop: '10px' }}>
              {omsOrders?.map((order, index) => (
                <tr
                  key={index}
                  style={{
                    fontSize: '14px',
                    margin: 10,
                    borderBottom: '1px solid #ddd',
                  }}
                >
                  <td>{order?.sku || order?.product?.sku || ''}</td>
                  <td>{order?.title || order?.product?.title}</td>
                  <td>{order?.quantity}</td>
                  <td>
                    £
                    {order?.price && order.price != 0 && order.price != 0.0
                      ? order.price
                      : order?.product?.price || 0}
                  </td>
                  <td>
                    £
                    {(
                      (order?.price && order.price != 0 && order.price != 0.0
                        ? order.price
                        : order?.product?.price || 0) * order?.quantity
                    ).toFixed(2)}
                  </td>
                  {order?.aiConfidenceScore && (
                    <td>{order?.aiConfidenceScore || ''}%</td>
                  )}
                </tr>
              ))}
            </tbody>
          </StyledTable>
        </div>
      ) : (
        <div style={{ fontSize: '14px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              {!parsedOrder?.order?.venue?.title && (
                <Text type='danger'>
                  <ExclamationCircleOutlined /> Venue Not Recognised
                </Text>
              )}
              <p>
                Venue Name:{' '}
                {parsedOrder?.order?.venue?.title ||
                  parsedOrder?.order?.venueName}
              </p>

              {venueSupplier && <p>Supplier: {venueSupplier?.title || ''}</p>}

              <p>Customer Name: {parsedOrder?.order?.customer?.name}</p>
              <p>Customer Email: {parsedOrder?.order?.customer?.email}</p>
              <p>
                Order Date:{' '}
                {new Date(
                  parsedOrder?.order?.order?.order_date,
                ).toLocaleDateString()}
              </p>
              <p>
                Delivery Date:{' '}
                {new Date(
                  parsedOrder?.order?.order?.delivery_date,
                ).toLocaleDateString() || 'Next Available Delivery Day'}
              </p>
            </div>
            <EditOutlined
              style={{
                fontSize: '20px',
                color: '#007bff',
                cursor: 'pointer',
                marginBottom: '180px',
              }}
              onClick={() => {
                const orderId = parsedOrder?._id
                if (orderId) {
                  window.open(
                    `/supplier/co-pilot/${orderId}/editOrder`,
                    '_blank',
                  )
                }
              }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              borderBottom: '1px solid #ddd',
              marginBottom: '15px',
            }}
          ></div>
          <StyledTable style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ fontSize: '14px' }}>
              <tr>
                <th>Sku</th>
                <th>Product</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Total</th>
                <th>Confidence Score</th>
              </tr>
            </thead>
            <tbody style={{ marginTop: '10px' }}>
              {newProducts?.map((product, index) => (
                <tr
                  key={index}
                  style={{
                    fontSize: '14px',
                    margin: 10,
                    position: 'relative',
                    borderBottom: '1px solid #ddd',
                  }}
                >
                  <td>{product.sku || ''}</td>
                  <td> {product?.title?.slice(0, 15)} </td>
                  <td>{product?.quantity || 1}</td>
                  <td>£{product?.price || 0}</td>
                  <td>
                    £{product?.total || product?.price * product?.quantity || 0}
                  </td>
                  {product?.confidence && <td>{product?.confidence * 100}%</td>}
                  <td
                    style={{
                      position: 'absolute',
                      width: '100%',
                      left: '0px',
                      bottom: '0px',
                      padding: 0,
                    }}
                  >
                    {supplierProducts?.length > 0 &&
                      product?._id &&
                      !isProductInSupplierList(
                        supplierProducts,
                        product?._id,
                      ) && (
                        <div>
                          <Text type='danger'>
                            <ExclamationCircleOutlined /> Not in supplier price
                            file
                          </Text>
                        </div>
                      )}
                  </td>
                </tr>
              ))}
            </tbody>
          </StyledTable>
        </div>
      )}
    </>
  )
}

export default CoPilotInterpretation
